import { Box } from '@jfs/ui-new'
import { createStackNavigator } from '@react-navigation/stack'
import { lazy, Suspense } from 'react';
import { Container } from '../../comps/Container'
import { RefundHeader } from '../../comps/RefundHeader'

import { LoadInitialsScreen } from '../../screens/LoadInitialsScreen'
import { UtrRefCustomerValidationScreen } from '../../screens/RefundFlow/UtrRefCustomerValidationScreen'
import { UtrRefundDetailScreen } from '../../screens/RefundFlow/UtrRefundDetailScreen'
import { Screens } from '../Screens'
import { HEADER_TITLE } from './ScreenHeaders'

const BCAgentOtp = lazy(() => import('../../screens/RefundFlow/BCAgentRefundOtp'))
const RefundCode = lazy(() => import('../../screens/RefundFlow/RefundCode'))
const RefundDetails = lazy(() => import('../../screens/RefundFlow/RefundDetails'))
const PendingRefunds = lazy(() => import('../../screens/RefundFlow/PendingRefunds'))
const RefundStatus = lazy(() => import('../../screens/RefundFlow/RefundStatus'))
const RegenerateRefundCode = lazy(() => import('../../screens/RefundFlow/RegenerateRefundCode'))
const BeneficiaryValidationLoader = lazy(() => import('../../screens/RefundFlow/BeneficiaryValdiationLoader'))
const RegenerateRefundCodeStatus = lazy(() => import('../../screens/RefundFlow/RegenerateRefundCodeStatus'))
const DataMisMatchModal = lazy(() => import('../../screens/RefundFlow/DataMisMatchModal'))

export const RefundStack = () => {
  const Stack = createStackNavigator()
  return (
    <Suspense fallback={<FallbackScreenRefund />}>
      <Stack.Navigator
        screenOptions={{
          headerTitle: HEADER_TITLE,
          header: RefundHeader,
        }}>
        <Stack.Screen name={Screens.LOAD_INITIALS} component={LoadInitialsScreen} />
        <Stack.Screen name={Screens.REFUND_CODE} component={RefundCode} />
        <Stack.Screen name={Screens.REFUND_DETAILS} component={RefundDetails} />
        <Stack.Screen name={Screens.BC_AGENT_OTP} component={BCAgentOtp} />
        <Stack.Screen name={Screens.REFUND_STATUS} component={RefundStatus} />

        <Stack.Screen name={Screens.REGENERATE_REFUND_CODE} component={RegenerateRefundCode} />
        <Stack.Screen name={Screens.PENDING_REFUNDS} component={PendingRefunds} />
        <Stack.Screen name={Screens.REFUND_CODE_REGENERATION_STATUS} component={RegenerateRefundCodeStatus} />
        <Stack.Screen name={Screens.UTR_REFUND_DETAIL_SCREEN} component={UtrRefundDetailScreen} />
        <Stack.Screen name={Screens.UTR_REF_CUSTOMER_VALIDATION_SCREEN} component={UtrRefCustomerValidationScreen} />
        {/* The same screen of pending refunds is used as Re-Generate Refund Code Details Screen */}

        <Stack.Screen name={Screens.BENEFICIARY_LOADER} component={BeneficiaryValidationLoader} />
        <Stack.Screen name={Screens.DATA_MISMATCH_SCREEN} component={DataMisMatchModal} />
      </Stack.Navigator>
    </Suspense>
  )
}

const FallbackScreenRefund = () => {
  return (
    <Box height={'100%'} flex={1}>
      <RefundHeader
        options={{
          headerShown: true,
          headerMode: 'screen',
          headerTitle: 'Refund Deposit',
          animationEnabled: false,
          cardOverlayEnabled: true,
          gestureDirection: 'horizontal',
          gestureEnabled: false,
          transitionSpec: {
            open: {
              animation: 'timing',
              config: {
                duration: 400,
              },
            },
            close: {
              animation: 'timing',
              config: {
                duration: 400,
              },
            },
          },
        }}
      />
      <Container type="refund" isLoading={true}>
        <Box minHeight={'30vh'}></Box>
      </Container>
    </Box>
  )
}
